import React from "react";
import Typography from "@mui/material/Typography";

const defaultSx = {
  color: "#1f1f1f",
  fontFamily: '"Noto Sans JP", sans-serif',
};

const BigHeadline = (props) => {
  const text = props.text;
  return (
    <Typography
      sx={{
        fontSize: 20,
        fontWeight: "bold",
        display: "block",
        mt: "60px",
        mb: "30px",
        p: 0,
        ...defaultSx,
        ...props.sx,
      }}
      textTransform="none"
    >
      {text}
    </Typography>
  );
};

const SmallHeadline = (props) => {
  const text = props.text;
  return (
    <Typography
      sx={{
        fontSize: 16,
        fontWeight: "bold",
        display: "block",
        mt: "30px",
        mb: "20px",
        p: 0,
        ...defaultSx,
        ...props.sx,
      }}
      textTransform="none"
    >
      {text}
    </Typography>
  );
};

const NormalText = (props) => {
  const text = props.text;
  return (
    <Typography
      sx={{
        fontSize: 14,
        display: "block",
        m: 0,
        p: 0,
        whiteSpace: "pre-wrap",
        ...defaultSx,
        ...props.sx,
      }}
      textTransform="none"
    >
      {text}
    </Typography>
  );
};

const NormalBoldText = (props) => {
  const text = props.text;
  return (
    <Typography
      sx={{
        fontSize: 14,
        display: "block",
        m: 0,
        p: 0,
        fontWeight: "bold",
        whiteSpace: "pre-wrap",
        ...defaultSx,
        ...props.sx,
      }}
      textTransform="none"
    >
      {text}
    </Typography>
  );
};

const SmallText = (props) => {
  const text = props.text;
  return (
    <Typography
      sx={{
        fontSize: 12,
        display: "block",
        m: 0,
        p: 0,
        whiteSpace: "pre-wrap",
        ...defaultSx,
        ...props.sx,
      }}
      textTransform="none"
    >
      {text}
    </Typography>
  );
};

export { BigHeadline, SmallHeadline, NormalText, NormalBoldText, SmallText };
